import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_PERSONALIZATION';

const en = {
    subForms_snooze: 'Maybe later',
    subForms_title: 'Personalize your Sublevel Forms',
    subForms_subTitle: '',
    subForms_hide: 'Hide',
    subForms_selectAll: 'Select all',
    subForms_design: 'Form Design',
    subForms_neverShowForm: "Don't suggest for X",
    subForms_neverShowAll: "I'm not interested",
    subForms_success_title: 'We successfully hid the sublevel forms',
    subForms_success_content:
        'You can always bring them back using Form Design. In the future, we will suggest more ways to customize the system according to your needs.',
    subForms_success_ok: 'OK',
    upperTitle: 'Recommendations for you',
    upperTitleActions: "Let's Organize your Actions",
    upperTitleActionsContinue:
        'We notice that you frequently use these actions. \n Do you want us to place them directly on the form?',
    yesReorder: 'Yes, please',
    orderMyself: "I'll organize",
    actionsUpdated: 'We successfully placed the actions first on the list.',
    actionsMoreInfo:
        'You can always change the order of the actions using Form Design. \n In the future, we will suggest more ways to customise the system according to your needs.',
    personalizeHomepageTitle: 'Personalise Your Homepage?',
    personalizeHomepageDescription: 'We notice that you frequently use these forms.',
    dontShowAgain: `​Don't show me again`,
    add: 'Add',
    addedToHomepage: 'We added X to your homepage',
    done: 'done',
    suggestionPreliminaryText:
        'We notice that you frequently use this search. We can add it to your saved searches so you can access it again with just one click.',
    searchNameLabel: 'Name your search',
    searchNamePlaceholder: 'Saved search X',
    saveSearch: 'Save my search',
    hideSubForms: 'Hide unused subforms',
    switchActions: 'Switch actions in form header',
    saveTopSearch: 'Save top search'
};

const he = {
    subForms_snooze: 'אחר כך',
    subForms_title: 'שנסתיר לך כמה ממסכי הבן?',
    subForms_subTitle: 'שמנו לב שיש כמה מסכי בן שלא השתמשת בהם לאחרונה. להסתיר אותם בינתיים?',
    subForms_hide: 'הסתרה',
    subForms_selectAll: 'לסמן הכול',
    subForms_design: 'עיצוב מסך',
    subForms_neverShowForm: 'לא להציג הצעות למסך זה',
    subForms_neverShowAll: 'לא להציג הצעות בכלל',
    subForms_success_title: 'הסתרנו את מסכי הבן בהצלחה',
    subForms_success_content:
        'אם צריך, אפשר להחזיר אותם בעזרת עיצוב המסך. בעתיד נציג לך עוד אפשרויות להתאמת המערכת לצרכים המדויקים שלך.',
    subForms_success_ok: 'אישור',
    upperTitle: 'המלצות במיוחד בשבילך',
    upperTitleActions: 'שנסדר את פעולות המסך שלך?',
    upperTitleActionsContinue:
        'שמנו לב שהפעולות השכיחות שלך לא מופיעות בראש המסך.\nנוכל למקם אותן עכשיו בראש המסך, כך שסביבת העבודה שלך תתאים בדיוק לך.',
    yesReorder: 'כן, לסדר אותן',
    orderMyself: 'אסדר בעצמי',
    actionsUpdated: 'עדכנו את הפעולות בכותרת המסך בהצלחה',
    actionsMoreInfo:
        'אם צריך, אפשר לשנות את הסדר בעזרת עיצוב הפעולות (תחת המסך). \n בעתיד נציג לך עוד אפשרויות להתאמת המערכת לצרכים המדויקים שלך.',
    personalizeHomepageTitle: 'שנסדר את מסך הבית שלך?',
    personalizeHomepageDescription: 'שמנו לב שיש במערכת כמה מסכים שימושיים במיוחד עבורך.',
    dontShowAgain: 'לא להציע לי שוב',
    add: 'הוספה',
    addedToHomepage: 'הוספנו את "X" למסך הבית שלך',
    done: 'סיום',
    suggestionPreliminaryText:
        'שמנו לב שזה חיפוש שיוצא לך להשתמש בו לא מעט. \n נוכל להוסיף אותו לחיפושים השמורים של המסך, כך שבפעם הבאה אפשר להפעיל אותו ברגע.',
    searchNameLabel: 'שם החיפוש',
    searchNamePlaceholder: 'חיפוש שמור X',
    saveSearch: 'שמרו את החיפוש שלי',
    hideSubForms: 'להסתיר מסכי בן שאינם בשימוש',
    switchActions: 'להחליף פעולות בראש המסך',
    saveTopSearch: 'לשמור חיפוש שכיח'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'personalizeHomepageTitle',
    2: 'personalizeHomepageDescription',
    3: 'subForms_snooze',
    4: 'dontShowAgain',
    5: 'add',
    6: 'addedToHomepage',
    7: 'subForms_title',
    8: 'subForms_subTitle',
    9: 'subForms_hide',
    10: 'subForms_selectAll',
    11: 'subForms_design',
    12: 'subForms_neverShowForm',
    13: 'subForms_neverShowAll',
    14: 'subForms_success_title',
    15: 'subForms_success_content',
    16: 'upperTitleActions',
    17: 'upperTitleActionsContinue',
    18: 'yesReorder',
    19: 'orderMyself',
    20: 'actionsUpdated',
    21: 'actionsMoreInfo',
    22: 'subForms_success_ok',
    23: 'upperTitle',
    24: 'done',
    25: 'suggestionPreliminaryText',
    26: 'searchNameLabel',
    27: 'searchNamePlaceholder',
    28: 'saveSearch',
    29: 'hideSubForms',
    30: 'switchActions',
    31: 'saveTopSearch'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
